// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs_container":"Breadcrumbs-module--breadcrumbs_container--dT8AJ","icon_wrapper":"Breadcrumbs-module--icon_wrapper--2MswS","icon":"Breadcrumbs-module--icon--1MkUA"};